export const PAGE_BACKGROUND_PREVIEW_SCALE = 1.5;
export const PAGE_BACKGROUND_SCROLL_SPEED_PX_PER_SEC = 18;
export const PAGE_BACKGROUND_BLUR_PX = 4;
export const PAGE_BACKGROUND_MIN_WIDTH_PX = 1024;
